// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import ResortSearchUI from '../src/ResortSearchUI';
import AccessUI from '../src/AccessUI';

document.addEventListener('turbolinks:load', () => {
  // '.resort-search-ui' can be multiple
  const doms = document.querySelectorAll('.resort-search-ui');
  Array.from(doms).forEach((dom) => {
    ReactDOM.render(<ResortSearchUI />, dom as HTMLElement);
  });
});
